import { TabValue } from '@fluentui/react-components';

import HistoryTable, { THistoryRow } from '@modules/items/components/HistoryTable';

import { TLiterature } from '../../types';

type TProps = {
  literature: TLiterature;
  setSelectedTab: (value: TabValue) => void;
};

const HistoryTab = ({ literature, setSelectedTab }: TProps) => {
  const rows: THistoryRow[] = [
    ...(literature.draft ? [{ id: 'draft', note: '', date: '', authorIds: literature.stats.authors ?? [] }] : []),
    ...literature.versions.map((v) => ({
      id: v.id,
      note: v.note,
      date: v.completedDate,
      authorIds: v.authors,
    })),
  ];

  return <HistoryTable rows={rows} versionedLabel="Versioned" onRowClick={() => setSelectedTab('home')} />;
};

export default HistoryTab;
